import './PaymentInfo.css';
import paypalLogo from '../assets/images/paypal-logo.svg';
import weroLogo from '../assets/images/wero-logo.svg';

const MEMBERSHIP_PAYMENTS = [
  {
    id: 'paypal',
    title: 'PayPal',
    description: 'Adresse e-mail : djeumodoriant@yahoo.fr',
    badgeClass: 'paypal',
    logo: paypalLogo
  },
  {
    id: 'wero',
    title: 'Wero',
    description: 'Numéro : +33 768 739 598',
    badgeClass: 'wero',
    logo: weroLogo
  }
];

const ARTICLE_PAYMENTS = [
  {
    id: 'paypal-articles',
    title: 'PayPal',
    description: 'Adresse e-mail : cedrichakoua@yahoo.ca',
    badgeClass: 'paypal',
    logo: paypalLogo
  },
  {
    id: 'wero-articles',
    title: 'Wero',
    description: 'Numéro : +33 769 308 797',
    badgeClass: 'wero',
    logo: weroLogo
  }
];

export default function PaymentInfo() {
  const ProofNote = () => (
    <p className="payment-info-note">
      Après paiement, envoyez la preuve à <strong>contact@unisportduhautnkam.com</strong> et/ou sur WhatsApp au
      <a
        href="https://wa.me/33650326167"
        target="_blank"
        rel="noopener noreferrer"
        className="payment-info-note__whatsapp"
        aria-label="Contacter via WhatsApp"
      >
        +33 650 326 167
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 2a9.9 9.9 0 0 0-6.995 16.903L4 22l3.221-.986A9.9 9.9 0 1 0 12 2zm0 1.8a8.1 8.1 0 0 1 5.729 13.838l-.286.278-.036.048a.9.9 0 0 0-.164.307l-.018.054-.54 1.632-1.681-.521-.052-.016a.9.9 0 0 0-.644.05l-.065.033-.067.025a8.1 8.1 0 1 1-2.176-15.468z"
          />
          <path
            fill="currentColor"
            d="M9.27 7.706c-.205-.462-.42-.471-.617-.48l-.527-.01c-.18.002-.472.068-.718.34s-.94.917-.94 2.237.963 2.593 1.096 2.773c.134.179 1.85 2.847 4.567 3.878 2.252.885 2.711.709 3.202.664.491-.045 1.576-.641 1.798-1.261.222-.62.222-1.151.155-1.261-.066-.11-.245-.178-.512-.313s-1.576-.777-1.819-.865c-.243-.089-.42-.134-.598.133-.179.268-.689.865-.845 1.043-.155.179-.311.2-.578.066-.268-.133-1.12-.413-2.133-1.316-.79-.704-1.322-1.573-1.477-1.84-.155-.268-.016-.413.117-.546.12-.12.268-.312.4-.467.133-.155.178-.268.268-.446.089-.178.044-.334-.022-.467-.066-.134-.588-1.423-.825-1.949z"
          />
        </svg>
      </a>
      .
    </p>
  );

  return (
    <div className="payment-info-page">
      <section className="payment-info-card">
        <h1>Paiement des frais</h1>
        <hr />
        <div className="payment-options">
          {MEMBERSHIP_PAYMENTS.map((option) => (
            <label key={option.id} className="payment-option">
              <span className="payment-option__radio" aria-hidden />
              <span className="payment-option__info">
                <strong>{option.title}</strong>
                <small>{option.description}</small>
              </span>
              {option.logo ? (
                <span className={`payment-option__badge payment-option__badge--${option.badgeClass}`}>
                  <img src={option.logo} alt={`${option.title} logo`} />
                </span>
              ) : (
                <span className="payment-option__badge payment-option__badge--wire">IB</span>
              )}
            </label>
          ))}
          <label className="payment-option">
            <span className="payment-option__radio" aria-hidden />
            <span className="payment-option__info">
              <strong>Virement bancaire</strong>
              <small>Nom / Prénom : DJEUMO DORIANT • IBAN : FR76 3008 7338 6300 0208 5990 127</small>
            </span>
            <span className="payment-option__badge payment-option__badge--wire">IB</span>
          </label>
        </div>
        <ProofNote />
      </section>

      <section className="payment-info-card">
        <h1>Paiement des articles</h1>
        <hr />
        <div className="payment-options">
          {ARTICLE_PAYMENTS.map((option) => (
            <label key={option.id} className="payment-option">
              <span className="payment-option__radio" aria-hidden />
              <span className="payment-option__info">
                <strong>{option.title}</strong>
                <small>{option.description}</small>
              </span>
              <span className={`payment-option__badge payment-option__badge--${option.badgeClass}`}>
                <img src={option.logo} alt={`${option.title} logo`} />
              </span>
            </label>
          ))}
        </div>
        <ProofNote />
      </section>
    </div>
  );
}
